import visszahivasKeresServiceModule from './../../services/visszahivas-keres';
import kapcsolatTemplate from './visszahivas-keres.pug';
import visszahivasKeresForm from './../visszahivas-keres-form/visszahivas-keres-form';
import uuidv1 from 'uuid/v1';
import { setTimeout } from 'timers';
const MODULE_NAME = 'visszahivasKeres';
class KapcsolatController {
	constructor(visszahivasKeresService, $rootScope, vcRecaptchaService, $element) {
		'ngInject';
		this.visszahivasKeresService = visszahivasKeresService;
		this.uuid = uuidv1;
		this.rootScope = $rootScope;
		this.vcRecaptchaService = vcRecaptchaService;
		this.$element = $element;
	}

	$onInit() {
		this.showForm = this.type == 'contactBar' ? false : true;
		this.visszahivasKeresService.getVisszahivasKeresInit().then(
			(response) => {
				this.getUuid((captchaId) => {
					this.initData = response.data;
					this.initData.captchaId = captchaId;
				});
			}, (error) => {
				this.rootScope.$broadcast('serverError');
				this.error = error;
		});
	}

	sendForm(model) {
		this.model = model;
		this.visszahivasKeresService.sendVisszahivas(this.model).then(
			(response) => {
				if (response.status == 200) {
					this.success = true;
					setTimeout(()=>{
						this.addFocusToElement('app-visszahivas-keres__success-text');
					});
				}
			},
			(error) => {
				this.formError = error;
				this.error = true;
			});
	}
	getUuid(callback) {
		callback(this.uuid());
	}
	addClassForResponsiveView() {
		let documentElement = angular.element(document);
		let bodyElemenet = documentElement.find('body');
		if (this.showForm) {
			bodyElemenet.removeClass("vhk-open");
		} else {
			bodyElemenet.addClass("vhk-open");
		}
	}
	showOrHideForm(event) {
		if (event) {
			event.preventDefault();
		}
		this.addClassForResponsiveView();
		this.success = false;
		this.showForm = !this.showForm;
		setTimeout(() => {
			this.addFocusToElement('onfocus');
		});
	}

	addFocusToElement(elemClass) {
		if (this.$element[0].getElementsByClassName(elemClass).length) {
			this.$element[0].getElementsByClassName(elemClass)[0].focus();
		}
	}
}

export default angular.module(MODULE_NAME, [visszahivasKeresServiceModule, visszahivasKeresForm])
	.component(MODULE_NAME, {
		controller: KapcsolatController,
		template: kapcsolatTemplate(),
		bindings: {
			id: '@',
			type: '@',
			documentUrl: '@'
		}
	}).name;



// WEBPACK FOOTER //
// ../source/application/visszahivas-keres/visszahivas-keres/visszahivas-keres.js